export enum PayType {
    SALARY_CONTINUANCE = 'Salary continuance',
    VACATION = 'Vacation',
    SICK_PAY = 'Sick pay',
    PAID_TIME_OFF = 'Paid time off'
}